'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    prevText: 'Prev',
    nextText: 'Next'
};
module.exports = exports['default'];